import { BrandId } from 'utils/override';

export function getDefaultMarketingConsent(brand: BrandId): boolean {
  return brand !== 'moneyhero';
}

export function getEmailValidationMessage(
  validity: {
    readonly valueMissing: boolean;
    readonly patternMismatch: boolean;
  },
  staticText: {
    readonly emailRequired: string;
    readonly emailInvalid: string;
  },
): string {
  if (validity.valueMissing) {
    return staticText.emailRequired;
  }

  if (validity.patternMismatch) {
    return staticText.emailInvalid;
  }

  return '';
}
